import type { MediaItem, MediaType, NewsItem } from "@/types/media";
import { movies, tvshows, shows } from "@/mocks/media";
import { newsList } from "@/mocks/news";

export const allMedia: MediaItem[] = [
  ...movies,
  ...tvshows,
  ...shows,
] as MediaItem[];

export const allNews: NewsItem[] = newsList as NewsItem[];

export function getMediaById(id: string): MediaItem | undefined {
  return allMedia.find((item) => item.id === id);
}

export function getNewsById(id: string): NewsItem | undefined {
  return allNews.find((item) => item.id === id);
}

export function getMediaByType(type: MediaType): MediaItem[] {
  return allMedia.filter((item) => item.type === type);
}

export function getRelatedMedia(item: MediaItem, limit = 4): MediaItem[] {
  const sameCategory = allMedia.filter(
    (m) => m.id !== item.id && m.category === item.category,
  );
  const sameType = allMedia.filter(
    (m) => m.id !== item.id && m.type === item.type && m.category !== item.category,
  );
  const rest = allMedia.filter(
    (m) => m.id !== item.id && m.type !== item.type && m.category !== item.category,
  );
  return [...sameCategory, ...sameType, ...rest].slice(0, limit);
}

export function getRelatedNews(item: NewsItem, limit = 3): NewsItem[] {
  const sameCategory = allNews.filter(
    (n) => n.id !== item.id && n.category === item.category,
  );
  const rest = allNews.filter(
    (n) => n.id !== item.id && n.category !== item.category,
  );
  return [...sameCategory, ...rest].slice(0, limit);
}

export function searchAll(keyword: string): {
  media: MediaItem[];
  news: NewsItem[];
} {
  const q = keyword.trim().toLowerCase();
  if (!q) return { media: [], news: [] };
  const matchMedia = allMedia.filter((item) =>
    [item.title, item.category, item.region, item.director, ...item.actors, ...item.tags]
      .join(" ")
      .toLowerCase()
      .includes(q),
  );
  const matchNews = allNews.filter((item) =>
    [item.title, item.summary, item.category, item.author]
      .join(" ")
      .toLowerCase()
      .includes(q),
  );
  return { media: matchMedia, news: matchNews };
}